import React, { useEffect, useState } from "react";
import styles from "./comboBox.module.scss";
import { getAwsAssets } from "@src/utils";

const SelectRadioComboBox = ({
  title,
  items,
  handleRadioChange,
  limit,
  index,
  setErrorStates,
  setPhysicalDeliveryEnabledStates,
}) => {
  const [selected, setSelected] = useState({});

  const blueTickIcon = getAwsAssets("blueTick.svg", "layout");

  const handleRadioChangeLocal = (checked, item) => {
    let temp = { ...selected };
    let keys = Object.keys(temp);

    for (let i = 0; i < keys.length; i++) {
      let key = keys[i];
      if (key === String(item?.courseId)) {
        temp[key] = true;
      } else {
        temp[key] = false;
      }
    }

    setSelected(temp);
  };

  useEffect(() => {
    let selectedObj = {};
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      selectedObj[item.courseId] = false;
    }
    setSelected(selectedObj);
  }, []);

  useEffect(() => {
    // CHECK FOR ERROR
    let atleastOneSelected = Object.keys(selected).some(
      (key) => selected[Number(key)] === true
    );

    if (atleastOneSelected) {
      setErrorStates((prev) => ({ ...prev, [index]: false }));
    } else {
      setErrorStates((prev) => ({ ...prev, [index]: true }));
    }

    handleRadioChange(selected);
  }, [selected]);

  useEffect(() => {
    // PHYSICAL DELIVERY
    for (let i = 0; i < items.length; i++) {
      const item = items[i];
      if (selected.hasOwnProperty(item?.courseId)) {
        if (
          selected[item?.courseId] === true &&
          item?.isPhysicalDeliveryEnabled
        ) {
          setPhysicalDeliveryEnabledStates((prev) => ({
            ...prev,
            [item?.courseId]: item?.isPhysicalDeliveryEnabled,
          }));
        } else {
          setPhysicalDeliveryEnabledStates((prev) => ({
            ...prev,
            [item?.courseId]: false,
          }));
        }
      }
    }
  }, [selected]);

  return (
    <div className={styles.comboBox}>
      <div className={styles.comboBoxTitle}>{title}</div>
      <div className={styles.comboBoxSubtitle}>Select any {limit}</div>
      <div className={styles.comboBoxCard}>
        {items &&
          items.map((item, index) => {
            return (
              <div
                key={index}
                onClick={() => {
                  if (!item?.isPurchased) {
                    handleRadioChangeLocal(false, item);
                  }
                }}
                className={styles.comboBoxCardSingleItem}
              >
                <div className={styles.comboBoxCardSingleItemLeft}>
                  {item?.facultyIcon ? (
                    <img
                      height={36}
                      width={36}
                      src={item?.facultyIcon}
                      alt="avatar"
                      style={{ borderRadius: "999px" }}
                    />
                  ) : (
                    <div className={styles.comboBoxAvatar}>
                      {item?.facultyName[0].toUpperCase()}
                    </div>
                  )}
                  <p>
                    {item?.facultyName}
                    {item?.isPurchased ? (
                      <div
                        style={{
                          fontSize: "12px",
                          padding: "6px",
                          color: "#7D8592",
                          background: "#FFF7E5",
                          marginTop: "8px",
                          fontWeight: 500,
                        }}
                      >
                        ALREADY PURCHASED
                      </div>
                    ) : null}
                  </p>
                </div>
                <div>
                  {selected[item?.courseId] === true ? (
                    <img
                      height={24}
                      width={24}
                      onClick={() => handleRadioChangeLocal(false, item)}
                      src={blueTickIcon}
                    />
                  ) : (
                    <input
                      disabled={item?.isPurchased}
                      className={styles.comboBoxCheckbox}
                      checked={selected[item?.courseId] === true}
                      style={{
                        background: item?.isPurchased ? "#eee" : "",
                        borderRadius: "999px",
                      }}
                      onChange={(e) => handleRadioChangeLocal(true, item)}
                      type="radio"
                    />
                  )}
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

export default SelectRadioComboBox;
